package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.UPDATE_MERCHANT_STAFF
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class UpdateMerchantStaffRequestModel(
    val staffId: Long,
    val email: String,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
    val dialCode: String = "",
    val role: String, // OWNER, MANAGER, STAFF
    val merchantLocationIds: List<Long> = emptyList(),
    /** Permission: the staff is allowed to create new bags. Locations are owner-only and never granted to staff. */
    val canCreateBags: Boolean = false,
    /** Permission: the staff sees the actual revenue figure on the dashboard. When false, the value is masked as "**.**". */
    val canViewRevenue: Boolean = false
) : BaseRequestModel(api = UPDATE_MERCHANT_STAFF)
